<script setup lang="ts">
import TeamCards from '@/views/apps/teams/TeamCards.vue'
import UserList from '@/views/apps/teams/UserList.vue'

// Define page meta for CASL permissions
definePage({
  meta: {
    action: 'manage',
    subject: 'Team',
  },
})

const { t } = useI18n()

// Ref for UserList component
const userListRef = ref()

// Handle refresh event from TeamCards
const handleRefreshUserList = () => {
  if (userListRef.value) {
    // Reload both users and teams data to update filters
    userListRef.value.loadUsers()
    userListRef.value.loadTeams()
  }
}
</script>

<template>
  <section>
    <!-- 👉 Page Header -->
    <div class="mb-6">
      <h1 class="text-h4 font-weight-bold mb-2">
        {{ t('teams.title') }}
      </h1>
      <p class="text-body-1 text-medium-emphasis">
        {{ t('teams.subtitle') }}
      </p>
    </div>

    <VRow>
      <!-- 👉 Teams Cards -->
      <VCol cols="12">
        <TeamCards @refresh-user-list="handleRefreshUserList" />
      </VCol>

      <VCol cols="12">
        <h4 class="text-h4 mb-1 mt-6">
          {{ t('teams.totalUsersWithTeams') }}
        </h4>
        <p class="text-body-1 mb-0">
          {{ t('teams.findUsersWithTeams') }}
        </p>
      </VCol>

      <VCol cols="12">
        <!-- 👉 User List  -->
        <UserList ref="userListRef" />
      </VCol>
    </VRow>
  </section>
</template>
